import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { PlatformLinesCard } from "./-components/platform-lines-card";

export const Route = createFileRoute("/_authenticated/platform_/lines")({
  beforeLoad: ({ context }) => guardRoute(context.me, "platform-lines"),
  component: PlatformLines,
});

/** Setting up People AI's own numbers. */
function PlatformLines() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="People AI lines"
        meta="The numbers on the platform's own account and who holds each."
      />
      <PlatformLinesCard />
    </div>
  );
}
